
export default class SurveysController {

	constructor (surveys, $state, Survey, $filter, User) {
		var translate = $filter('translate');
		var buttons = [
			{ label: translate('ACTIVATE'),                                        action: this.toggleActive.bind(this), test: survey => !survey.active && User.get().super },
			{ label: translate('DEACTIVATE'),                                      action: this.toggleActive.bind(this), test: survey => survey.active && User.get().super },
			{ label: translate('EDIT'),       icon: 'pencil',                      action: this.edit.bind(this),	test: () => User.get().super },
			{ label: translate('REMOVE'),     icon: 'cross',                       action: this.remove.bind(this),	test: () => User.get().super },
			{ label: translate('STATS'),      icon: 'stats-bars', type: 'primary', action: this.stats.bind(this) },
		];
		this.headers = [
			{ key: 'id',         label: '#',                     type: 'text' },
			{ key: 'title',      label: translate('TITLE'),      type: 'text' },
			{ key: 'createdBy',  label: translate('CREATED_BY'), type: 'text' },
			{ key: 'createdAt',  label: translate('CREATED_AT'), type: 'date' },
			{ key: 'updatedAt',  label: translate('UPDATED_AT'), type: 'date' },
			{ key: 'active',     label: translate('ACTIVE'),     type: 'check' },
			{ key: '',           label: '',                      type: 'buttons', buttons },
		];
		this.User = User;
		this.surveys = surveys;
		this.Survey = Survey;
		this.$state = $state;
		this.translate = translate;
	}

	create () {
		swal({
			title: this.translate('SURVEY_CREATION'),
			text: `${this.translate('TITLE')}`,
			type: 'prompt',
			showCancelButton: true
		}, title => title && this.Survey.create({ title }).then(this.edit.bind(this)));
	}

	edit (survey) {
		this.$state.go('surveyEditPage', survey);
	}

	stats (survey) {
		this.$state.go('surveyStatsPage', survey);
	}

	reload () {
		this.$state.go('surveysPage', {}, { reload: true });
	}

	active (survey) {
		return survey.active;
	}

	toggleActive (survey) {
		swal({
			title: this.translate('ARE_YOU_SURE'),
			text: `${this.translate(survey.active ? 'QUESTION_DEACTIVATE_SURVEY' : 'QUESTION_ACTIVATE_SURVEY')} "${survey.title}"`,
			type: 'warning',
			showCancelButton: true
		}, confirm => confirm && this.Survey.update(survey.id, {
			active: !survey.active
		}).then(this.reload.bind(this)));
	}

	remove (survey) {
		swal({
			title: this.translate('ARE_YOU_SURE'),
			text: `${this.translate('QUESTION_DELETE_SURVEY')} "${survey.title}"`,
			type: 'warning',
			showCancelButton: true
		}, confirm => confirm && this.Survey.delete(survey.id).then(this.reload.bind(this)));
	}

}

SurveysController.$inject = ['surveys', '$state', 'Survey', '$filter', 'User'];



// WEBPACK FOOTER //
// ./src/page/surveys/surveys.controller.js